import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {string} from 'vue-types';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Skeleton',
  props: {
        height: string().def('44px'),
        width: string().def('100%'),
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "skeleton",
    style: _normalizeStyle({width: __props.width, height: __props.height})
  }, null, 4))
}
}

})